import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { authApi } from '../services/api';
import logo from '../assets/logo.png';
import Modal from '../components/Modal';
import LoadingOverlay from '../components/LoadingOverlay';

export default function ResetPasswordPage() {
  const [searchParams]        = useSearchParams();
  const navigate              = useNavigate();
  const token                 = searchParams.get('token') || '';
  const emailParam            = searchParams.get('email') || '';

  const [password, setPassword]   = useState('');
  const [confirm, setConfirm]     = useState('');
  const [loading, setLoading]     = useState(false);
  const [success, setSuccess]     = useState(false);
  const [error, setError]         = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (password !== confirm) {
      setError('Le password non coincidono.');
      return;
    }
    if (password.length < 8) {
      setError('La password deve essere di almeno 8 caratteri.');
      return;
    }

    setLoading(true);
    try {
      await authApi.resetPassword({
        token,
        email: emailParam,
        password,
        password_confirmation: confirm,
      });
      setSuccess(true);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Token non valido o scaduto. Richiedi un nuovo link.');
    } finally {
      setLoading(false);
    }
  };

  if (!token || !emailParam) {
    return (
      <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
        <div style={{ maxWidth: 390, width: '100%', textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 16 }}>
          <span className="mi" style={{ fontSize: 48, color: 'var(--error, #f87171)', display: 'block' }}>link_off</span>
          <p style={{ fontSize: 18, fontWeight: 700, color: 'var(--text-1)' }}>Link non valido</p>
          <p className="sub">Questo link di reset non è valido. Richiedine uno nuovo.</p>
          <Link to="/forgot-password" className="btn btn-primary" style={{ textDecoration: 'none', display: 'block' }}>
            Richiedi nuovo link
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '100%', maxWidth: 390, display: 'flex', flexDirection: 'column', gap: 24 }}>

        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8 }}>
          <img src={logo} alt="Molti Like" style={{ width: 220, height: 'auto', objectFit: 'contain' }} />
        </div>

        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: 22, fontWeight: 700, color: 'var(--text-1)', marginBottom: 6, letterSpacing: '-0.02em' }}>Nuova Password</p>
          <p className="sub">Scegli una nuova password per il tuo account.</p>
        </div>

        {success && <Modal isOpen title="Password aggiornata!" message="Ora puoi accedere con la nuova password." type="success" confirmText="Vai al login" onConfirm={() => navigate('/login')} />}
        {success ? null : (
          <>
            {loading && <LoadingOverlay title="Aggiornamento della password..." subtitle="Un momento" icon="lock_reset" />}
            {error && <Modal isOpen title="Controlla i dati" message={error} type="error" onConfirm={() => setError('')} />}
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div className="form-group">
                <label className="form-label">Nuova password</label>
                <input
                  className="form-input"
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Almeno 8 caratteri"
                  autoComplete="new-password"
                  required
                />
              </div>
              <div className="form-group">
                <label className="form-label">Conferma password</label>
                <input
                  className="form-input"
                  type="password"
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  placeholder="Ripeti la password"
                  autoComplete="new-password"
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading} style={{ marginTop: 4 }}>
                Salva nuova password
              </button>
            </form>
          </>
        )}

        <p style={{ textAlign: 'center', fontSize: 13, color: 'var(--text-2)' }}>
          <Link to="/login" style={{ color: 'var(--primary)', fontWeight: 600, textDecoration: 'none' }}>
            ← Torna al login
          </Link>
        </p>
      </div>
    </div>
  );
}
